import React, { useEffect,useState } from 'react';

import ZpButton from 'components/zpButton';

const BottomClusterNavigation = ({ subheaderItems, hideNext = false, jobTitle }) => {
  const [prevPage, setPrevPage] = useState(0);
  const [nextPage, setNextPage] = useState(0);

  const currentPageIndex = subheaderItems
    ? subheaderItems.findIndex((item) => item.isCurrentPage)
    : null;

  useEffect(() => {
    switch (currentPageIndex) {
      case 0:
        setPrevPage(subheaderItems.length - 1);
        setNextPage(currentPageIndex + 1);
        break;
      case subheaderItems.length - 1:
        setPrevPage(currentPageIndex - 1);
        setNextPage(0);
        break;
      default:
        setPrevPage(currentPageIndex - 1);
        setNextPage(currentPageIndex + 1);
        break;
    }
  }, []);

  const navigateToPage = (page) => {
    window.location.href = subheaderItems[page].link;
  };

  return (
    <div className="container bottom-cluster-navigation px-0 d-flex justify-content-between align-items-center">
      {currentPageIndex !== -1 && (
        <>
          <ZpButton
            theme="secondary"
            size="big"
            icon={<i className="submenuArrowIcon" aria-hidden="true" />}
            onClick={() => navigateToPage(prevPage)}
            className="prev d-sm-block d-none"
          >
            <span className="button-direction">Previous:</span>
            <span className="page-name">{`${jobTitle ? `${jobTitle} ` : ''}${
              subheaderItems[prevPage].title
            }`}</span>
          </ZpButton>
          {subheaderItems[nextPage] && !hideNext && (
            <ZpButton
              theme="secondary"
              size="big"
              isLeftIcon={false}
              icon={<i className="submenuArrowIcon" aria-hidden="true" />}
              onClick={() => navigateToPage(nextPage)}
              className="next"
            >
              <span className="button-direction">Next: </span>
              <span className="page-name">{`${jobTitle ? `${jobTitle} ` : ''}${
                subheaderItems[nextPage].title
              }`}</span>
            </ZpButton>
          )}
        </>
      )}
    </div>
  );
};

export default React.memo(BottomClusterNavigation);
